import React from 'react'
import {css} from '@emotion/react'
import styled from '@emotion/styled'

import {Grid} from '@daedalus/atlas/helpers/Grid'
import {SkeletonLoader} from '@daedalus/atlas/SkeletonLoader'

const SkeletonWrapper = styled.div(
  ({theme}) => css`
    width: 100%;
    padding: ${theme.layout.spacing.s400}px;
  `
)
const InfoWrapper = styled.div`
  width: 100%;
  height: 62px;
`

const RatingWrapper = styled(Grid)(
  ({theme}) => css`
    margin-top: ${theme.layout.spacing.s400}px;
  `
)

const RatingTextWrapper = styled.div(
  ({theme}) => css`
    margin-left: ${theme.layout.spacing.s250}px;
  `
)

export const PropertySummarySkeleton = () => (
  <SkeletonWrapper>
    <InfoWrapper>
      <SkeletonLoader width={67} height={12} />
      <SkeletonLoader height={24} marginTop={4} width={100} />
      <SkeletonLoader height={20} marginTop={2} width={155} />
    </InfoWrapper>
    <RatingWrapper
      container
      alignItems="center"
      justify="flex-start"
      spacing="s000"
    >
      <SkeletonLoader height={32} width={32} />

      <RatingTextWrapper>
        <SkeletonLoader width={55} height={20} />
        <SkeletonLoader width={79} height={15} marginTop={2} />
      </RatingTextWrapper>
    </RatingWrapper>
  </SkeletonWrapper>
)
